import { apiService } from "api/apiService";
import type { ChatResource } from "api/generated";

export const updateChat = async (
  chatId: string,
  message: string,
): Promise<ChatResource> => {
  const { data } = await apiService.put<ChatResource>(`api/chats/${chatId}`, {
    message,
  });

  return data;
};
